exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".TitleAndImages-module__title-and-images___108BB{display:grid;gap:24px}.TitleAndImages-module__title-and-images___108BB h2{font-weight:400;font-size:26px;text-transform:capitalize;line-height:1.1}.TitleAndImages-module__title-and-images___108BB.TitleAndImages-module__in-popup___3MiM- .TitleAndImages-module__image-wrapper___NJFrN{padding-bottom:68%}.TitleAndImages-module__title-and-images___108BB .TitleAndImages-module__image-wrapper___NJFrN{width:100%;height:100%;position:relative;grid-area:image}.TitleAndImages-module__title-and-images___108BB .TitleAndImages-module__image-wrapper___NJFrN img{height:100%;width:100%;-o-object-fit:contain;object-fit:contain;position:absolute}", ""]);

// exports
exports.locals = {
	"title-and-images": "TitleAndImages-module__title-and-images___108BB",
	"in-popup": "TitleAndImages-module__in-popup___3MiM-",
	"image-wrapper": "TitleAndImages-module__image-wrapper___NJFrN"
};